import { Ban, ChevronRight, Crown, Shield } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { tierDisplayName, type Tier } from "@/lib/tier";
import { labelFor, type AdminUser } from "./types";

type Props = {
  user: AdminUser;
  isSelf: boolean;
  onClick: () => void;
};

export const UserListRow = ({ user: u, isSelf, onClick }: Props) => (
  <button
    onClick={onClick}
    className="flex w-full flex-col gap-1 rounded-md border border-border p-3 text-left transition-colors hover:bg-muted/40 sm:flex-row sm:items-center sm:justify-between"
  >
    <div className="min-w-0">
      <div className="flex items-center gap-2">
        <span className="truncate font-medium">{labelFor(u)}</span>
        {isSelf && <Badge variant="outline" className="text-xs">you</Badge>}
      </div>
      <div className="text-xs text-muted-foreground truncate">{u.email}</div>
    </div>
    <div className="flex flex-wrap items-center gap-2 sm:justify-end">
      {u.account_tier && (
        <Badge variant="secondary">{tierDisplayName(u.account_tier as Tier)}</Badge>
      )}
      {u.roles.includes("super_admin") && (
        <Badge className="gap-1"><Crown className="h-3 w-3" /> Super Admin</Badge>
      )}
      {u.roles.includes("admin") && !u.roles.includes("super_admin") && (
        <Badge variant="secondary" className="gap-1"><Shield className="h-3 w-3" /> Admin</Badge>
      )}
      {u.is_banned && (
        <Badge variant="destructive" className="gap-1"><Ban className="h-3 w-3" /> Banned</Badge>
      )}
      <ChevronRight className="h-4 w-4 text-muted-foreground" />
    </div>
  </button>
);
